/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * GeChiUI dependencies
 */
import { forwardRef } from '@gechiui/element';

const PanelRow = forwardRef( ( { className, children }, ref ) => (
	<div
		className={ classnames( 'components-panel__row', className ) }
		ref={ ref }
	>
		{ children }
	</div>
) );

export default PanelRow;
